import { render, staticRenderFns } from "./MedicalStaffAssign.vue?vue&type=template&id=c7b70400"
import script from "./MedicalStaffAssign.vue?vue&type=script&lang=js"
export * from "./MedicalStaffAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports